/**
 * Live Helene layers for the EPA demo. Titles match Gulf of America ERMA.
 * Best-track FeatureServer layers are the NHC AL092024 shapefile names (pts /
 * lin / windswath). CZMA is NOAA OCM’s national CZMA boundary — the overlay
 * ERMA shows with Helene, not a storm track.
 */

export const EPA_ERMA_HELENE_PTS_LAYER_ID = 'epa-erma-helene-pts';
export const EPA_ERMA_HELENE_LIN_LAYER_ID = 'epa-erma-helene-lin';
export const EPA_ERMA_HELENE_SWATH_LAYER_ID = 'epa-erma-helene-swath';
export const EPA_ERMA_HELENE_CZMA_LAYER_ID = 'epa-erma-helene-czma';
export const EPA_ERMA_NPL_LAYER_ID = 'epa-erma-npl-superfund';
export const EPA_ERMA_NPL_LAYER_TITLE =
  'National Priorities List Superfund Sites with Status Information (EPA)';

const HELENE_BEST_TRACK_FEATURE_SERVER =
  'https://services5.arcgis.com/pGZTLavDTVHngCQj/arcgis/rest/services/Helene_best_Track_WFL1/FeatureServer';

export const EPA_ERMA_HELENE_SWATH_URL = `${HELENE_BEST_TRACK_FEATURE_SERVER}/2`;

export const EPA_NPL_SUPERFUND_FEATURE_SERVER_URL =
  'https://services.arcgis.com/cJ9YHowT8TU7DUyn/arcgis/rest/services/Superfund_National_Priorities_List_(NPL)_Sites_with_Status_Information/FeatureServer/0';

export const EPA_ERMA_HELENE_LAYERS = [
  {
    id: EPA_ERMA_HELENE_PTS_LAYER_ID,
    title: 'Hx Helene Best Track Points (NHC)',
    url: `${HELENE_BEST_TRACK_FEATURE_SERVER}/0`,
  },
  {
    id: EPA_ERMA_HELENE_LIN_LAYER_ID,
    title: 'Hx Helene Best Track Line (NHC)',
    url: `${HELENE_BEST_TRACK_FEATURE_SERVER}/1`,
  },
  {
    id: EPA_ERMA_HELENE_SWATH_LAYER_ID,
    title: 'Hx Helene Best Track Wind Swath (NHC)',
    url: EPA_ERMA_HELENE_SWATH_URL,
  },
  {
    id: EPA_ERMA_HELENE_CZMA_LAYER_ID,
    title: 'Hurricane Helene - CZMA (NOAA)',
    url: 'https://coast.noaa.gov/arcgis/rest/services/Hosted/CoastalZoneManagementAct/FeatureServer/0',
  },
] as const;

export const EPA_ERMA_HELENE_LAYER_IDS = EPA_ERMA_HELENE_LAYERS.map(
  (layer) => layer.id
);
